import React from 'react';
import styled from 'styled-components';
import { colors } from '~/styles';
import Tag from './Tag';
import Tooltip from './Tooltip';

const Container = styled.div`
  display: flex;

  ${Tag} {
    color: ${colors.black};
    background-color: ${colors.grey5};
  }
`;

const TooltipContainer = styled.div`
  ${Tag} {
    color: ${colors.black};
    background-color: ${colors.grey5};
  }
`;

export default function TagsList({ children, ...props }) {
  if (!children) return null;

  const [first, ...rest] = React.Children.toArray(children);

  return (
    <Container {...props}>
      {first}

      {rest.length > 0 && (
        <Tooltip message={<TooltipContainer>{rest.map((child) => child)}</TooltipContainer>}>
          <Tag style={{ color: colors.grey40 }}>{`+${rest.length}`}</Tag>
        </Tooltip>
      )}
    </Container>
  );
}
